import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Icons, ImpBadgeText, ImpButton, ImpContainer, ImpFlex, ImpIcon, ImpNavIcon, ImpSpacer, ImpText, colors, zIndex, } from '../..';
const BackgroundShape = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "207px", viewBox: "0 0 393 207", fill: "none", preserveAspectRatio: "none" },
    React.createElement("path", { d: "M0 0H393V127L0 207V0Z", fill: "var(--merchant-color)" })));
const Container = styled.div `
  width: 600px;
  height: 100dvh;
  background-color: ${colors.surface.surfaceLow};
  display: flex;
  flex-direction: column;

  @media (max-width: ${Breakpoints.Mobile}) {
    width: 100vw;
  }
`;
const CloseWrapper = styled(ImpContainer) `
  top: 4px;
  right: 8px;
`;
const AsteriskWrapper = styled(ImpContainer) `
  right: 10%;
  bottom: 20%;
`;
const ContentContainer = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 24px;
`;
const ButtonContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  margin: auto;
`;
export default function FeatureAnnouncementPage({ badgeText, title, subtitle, buttonText, onPrimaryClick, onCloseClick, }) {
    return (React.createElement(Container, null,
        React.createElement(ImpContainer, { position: "relative" },
            React.createElement(BackgroundShape, null),
            React.createElement(CloseWrapper, { position: "absolute", zIndex: zIndex.image },
                React.createElement(ImpNavIcon.Close, { stroke: colors.content.onBackgroundInverse, onClick: onCloseClick })),
            React.createElement(AsteriskWrapper, { backgroundColor: colors.surface.surfaceLow, width: "56px", height: "56px", borderRadius: "50%", position: "absolute", zIndex: zIndex.image },
                React.createElement(ImpIcon, { iconSrc: Icons.asterisk, stroke: "var(--merchant-color)", strokeWidth: "2.5", padding: "8px" }))),
        React.createElement(ContentContainer, null,
            React.createElement(ImpFlex, { direction: "column", fluid: true },
                React.createElement(ImpBadgeText, { variant: "primary", color: "var(--merchant-color)" }, badgeText),
                React.createElement(ImpSpacer, { height: "l" }),
                React.createElement(ImpText, { typography: "display3", color: colors.content.onSurface, handleSuperscript: true }, title),
                React.createElement(ImpSpacer, { height: "s" }),
                React.createElement(ImpText, { typography: "body1", color: colors.content.onSurfaceVariant, handleSuperscript: true }, subtitle)),
            React.createElement(ButtonContainer, null,
                React.createElement(ImpButton, { size: "fill", variant: "primary", buttonStyle: "branded", onClick: onPrimaryClick }, buttonText)))));
}
//# sourceMappingURL=FeatureAnnouncementPage.js.map